import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=7f36be5c&scoped=true"
import script from "./PageButton.vue?vue&type=script&lang=js"
export * from "./PageButton.vue?vue&type=script&lang=js"
import style0 from "./PageButton.vue?vue&type=style&index=0&id=7f36be5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36be5c",
  null
  
)

export default component.exports